// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3JcLS","content":"Consent_content__iEbj_","footer":"Consent_footer__ZDHj_"};